function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-11{fill:#fff;}.cls-110{fill:none;stroke:#adafb5;stroke-miterlimit:10;stroke-width:3px;}.cls-113{fill:#adafb5;}\n        "));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-11",
  width: 60,
  height: 60
}), React.createElement("line", {
  className: "cls-110",
  x1: 25.95,
  y1: 19.76,
  x2: 25.95,
  y2: 43.7
}), React.createElement("path", {
  className: "cls-110",
  d: "M38.39,25.2h0A12.44,12.44,0,0,0,26,37.65v.25"
}), React.createElement("path", {
  className: "cls-11",
  d: "M26,19.21a3.69,3.69,0,1,1,3.68-3.69A3.69,3.69,0,0,1,26,19.21Z"
}), React.createElement("path", {
  className: "cls-113",
  d: "M26,12.84a2.69,2.69,0,1,1-2.69,2.68A2.69,2.69,0,0,1,26,12.84m0-2a4.69,4.69,0,1,0,4.68,4.68A4.69,4.69,0,0,0,26,10.84Z"
}), React.createElement("path", {
  className: "cls-11",
  d: "M26,48.16a3.69,3.69,0,1,1,3.68-3.68A3.69,3.69,0,0,1,26,48.16Z"
}), React.createElement("path", {
  className: "cls-113",
  d: "M26,41.79a2.69,2.69,0,1,1-2.69,2.69A2.7,2.7,0,0,1,26,41.79m0-2a4.69,4.69,0,1,0,4.68,4.69A4.69,4.69,0,0,0,26,39.79Z"
}), React.createElement("path", {
  className: "cls-11",
  d: "M42.05,28.88a3.68,3.68,0,1,1,3.69-3.68A3.68,3.68,0,0,1,42.05,28.88Z"
}), React.createElement("path", {
  className: "cls-113",
  d: "M42.05,22.52a2.68,2.68,0,1,1-2.68,2.68,2.69,2.69,0,0,1,2.68-2.68m0-2a4.68,4.68,0,1,0,4.69,4.68,4.69,4.69,0,0,0-4.69-4.68Z"
})));

function SvgFork(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/fork.0538d300.svg";
export { SvgFork as ReactComponent };